import { Button } from 'components/common'
import Modal from 'components/modal'
import useModal from 'hooks/useModal'
import { useState } from 'react'
import toast from 'react-hot-toast'
import { runPickerFullSyncApi } from 'utils/api/pickerEmpMapApi'
import { handleError } from 'utils/helpers/handleError'

// Pulls every picker from Order Tracker - for the first load or recovery
const PickerFullSyncButton = ({ onSynced }: { onSynced: () => void }) => {
  const { isOpen, openModal, closeModal } = useModal()
  const [syncing, setSyncing] = useState(false)

  const handleSync = async () => {
    closeModal()
    setSyncing(true)
    const syncToast = toast.loading('Syncing pickers from Order Tracker...')
    try {
      const { data } = await runPickerFullSyncApi()
      toast.success(
        `Pickers synced: ${data?.upserted ?? 0} updated, ${
          data?.deleted ?? 0
        } removed.`,
        { id: syncToast },
      )
      onSynced()
    } catch (error) {
      handleError(error, syncToast, {
        default: 'Failed to sync pickers from Order Tracker.',
      })
    } finally {
      setSyncing(false)
    }
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        size="small"
        className="!border !py-1.5 !font-normal"
        buttonText="Sync from Order Tracker"
        onClick={openModal}
        loading={syncing}
        disabled={syncing}
      />

      <Modal
        width={500}
        title="Sync pickers from Order Tracker?"
        titleClassname="text-xl font-semibold"
        isOpen={isOpen}
        closeModal={closeModal}
        customStyle={{ padding: '25px 30px' }}
      >
        <>
          <p className="text-sm text-gray-700">
            Pulls every picker from Order Tracker and updates this list. Pickers
            no longer in Order Tracker are removed, together with their picker
            names and old app login. Changes normally arrive automatically - use
            this for the first load or if pickers look out of date.
          </p>
          <div className="mt-6 flex w-full items-center gap-5">
            <Button
              className="w-full"
              type="button"
              buttonText="Sync now"
              onClick={handleSync}
            />
            <Button
              className="w-full"
              type="button"
              variant="outline"
              buttonText="Cancel"
              onClick={closeModal}
            />
          </div>
        </>
      </Modal>
    </>
  )
}

export default PickerFullSyncButton
